<template src="./Errormsg.html"></template>
<style scoped src="./Errormsg.scss" lang="scss"></style>
<script>
export default {};
</script>
